export class Keys {
  applicationServerKey =
    'BIxgxpz-2yCxYhx5a0sSByNCD8_X4lFciyI7ZfazdYFm_tYE7nZjlmzJHnikFnhblepF_BuKbTDKeFaMiRgR8-Y';
}

export default new Keys();
